import { Loader } from '@nosinovacao/fe-icons';
import { Button, Captcha, If, Input, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type NewContactProps } from '../-model/props';

export function NewContactLight({
  isPhone,
  form,
  isSubmitting,
  captcha,
  onSubmit,
}: Readonly<NewContactProps>) {
  const { t } = useI18n();

  return (
    <form
      className="flex h-full flex-col gap-6"
      onSubmit={form.handleSubmit(onSubmit)}
      data-tid="form-new-contact"
    >
      <span className="text-nos-neutral-700 font-text-p1" data-tid="text-new-contact-description">
        {t(
          isPhone
            ? 'Home.ChangeContacts.NewContact.Description.Phone'
            : 'Home.ChangeContacts.NewContact.Description.Email',
        )}
      </span>

      <div className="flex flex-col gap-4">
        <Input
          skin="light"
          id={form.ids.value ?? (isPhone ? 'new-phone-number' : 'new-email')}
          label={t(
            isPhone
              ? 'Home.ChangeContacts.NewContact.PhoneLabel'
              : 'Home.ChangeContacts.NewContact.EmailLabel',
          )}
          value={form.value.value}
          errors={form.errors.value}
          onChange={(ev) => form.setValue('value', ev.target.value)}
          type={isPhone ? 'tel' : 'text'}
          inputMode={isPhone ? 'tel' : 'text'}
          data-tid={isPhone ? 'input-new-phone' : 'input-new-email'}
        />
      </div>

      <If condition={captcha.challenge}>
        <Captcha onChange={captcha.setToken} />
      </If>

      <div className="mt-auto flex flex-col gap-3 pb-4">
        <Button
          skin="light"
          variant="primary"
          className="w-full tablet:w-fit"
          disabled={!form.value.value || isSubmitting}
          type="submit"
          data-tid="button-submit-new-contact"
        >
          {isSubmitting ? (
            <Loader width={20} height={20} className="animate-spin" />
          ) : (
            t('Home.ChangeContacts.NewContact.Submit')
          )}
        </Button>
      </div>
    </form>
  );
}
